
namespace RedBullMOBILE360.AutomaticReports {
    export class ReportColumns {
        static columnsKey = 'AutomaticReports.Report';
    }
}